// Layout types - geometry only, sources are in presets
/** LayoutBorder field -> flat layout column. */
export const LAYOUT_BORDER_COLUMNS = {
    color: "border_color",
    width: "border_width",
    innerWidth: "border_inner_width",
    outerSoftness: "border_outer_softness",
    innerSoftness: "border_inner_softness",
    bevel: "border_bevel",
    bevelPosition: "border_bevel_position",
    bevelSoftness: "border_bevel_softness",
    lightDirection: "border_light_direction",
    lightAltitude: "border_light_altitude",
};
/** Numeric border columns with their switcher ranges. */
export const LAYOUT_BORDER_RANGES = {
    border_width: [0, 1600],
    border_inner_width: [0, 1600],
    border_outer_softness: [0, 100],
    border_inner_softness: [0, 100],
    border_bevel: [0, 3],
    border_bevel_position: [0, 100],
    border_bevel_softness: [0, 100],
    border_light_direction: [0, 3599],
    border_light_altitude: [10, 100],
};
/** The border settings of a layout. */
export function layoutBorder(layout) {
    const border = { enabled: !!layout.border_enabled };
    for (const [field, column] of Object.entries(LAYOUT_BORDER_COLUMNS)) {
        const value = layout[column];
        if (value === undefined || value === null || value === "")
            continue;
        border[field] = value;
    }
    return border;
}
/** The flat layout fields for a border (the inverse of {@link layoutBorder}). */
export function layoutBorderFields(border) {
    const fields = { border_enabled: border.enabled };
    for (const [field, column] of Object.entries(LAYOUT_BORDER_COLUMNS)) {
        const value = border[field];
        if (value !== undefined) {
            fields[column] = value;
        }
    }
    return fields;
}
/**
 * The layout border in the switcher's protocol terms, as the push sends it
 * (missing fields: the switcher's minimum, for previews). The colour is
 * converted by the caller (see ssHexToBorderHsl).
 */
export function layoutBorderProtocol(border) {
    const out = {
        enabled: border.enabled,
    };
    const set = (key, v) => {
        if (v !== undefined && v !== null)
            out[key] = v;
    };
    set("outerWidth", border.width);
    set("innerWidth", border.innerWidth ?? (border.width !== undefined ? 0 : undefined));
    set("outerSoftness", border.outerSoftness);
    set("innerSoftness", border.innerSoftness);
    set("bevel", border.bevel);
    set("bevelPosition", border.bevelPosition);
    set("bevelSoftness", border.bevelSoftness);
    set("lightSourceDirection", border.lightDirection);
    set("lightSourceAltitude", border.lightAltitude);
    return out;
}
/** Most box layers a layout can have: a SuperSource has four boxes. */
export const SS_LAYOUT_MAX_LAYERS = 4;
// Default values
export const DEFAULT_LAYOUT_ART = {
    use_premultiplied_key: false,
    clip: 0,
    gain: 1000,
    invert_key: false,
};
export const DEFAULT_TRANSITION = {
    type: "cut",
    duration_ms: 0,
};
// Builtin layout templates
export const BUILTIN_TEMPLATES = [
    "2-way-horizontal",
    "2-way-vertical",
    "3-way-large-left",
    "3-way-large-right",
    "4-way-grid",
    "pip-bottom-right",
    "pip-bottom-left",
    "pip-top-right",
    "pip-top-left",
];
